/* oxlint-disable react/jsx-no-constructed-context-values */
import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitRoot, UiKitToastsContextProvider } from '@cian/ui-kit';

import { getIsLeadFactory } from '../../selectors/newbuilding';
import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { NewbuildingCallbackWidgetProvider } from '../NewbuildingCallbackWidgetProvider';
import { NewbuildingBrokerModalsProvider } from '../NewbuildingBrokerModalsProvider';
import { NewbuildingPurchaseGiftPromoProvider } from '../NewbuildingPurchaseGiftPromo';
import { StandardPage } from './StandardPage';
import { LeadFactoryPage } from './LeadFactoryPage';
import { AppEffects } from './AppEffects';

import './App.css';

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  /**
   * Заглушка корневого error boundary. В браузере это снимок SSR-разметки,
   * чтобы при ошибке после гидрации контент не стирался; на сервере не передаётся.
   */
  errorStub?: React.ReactElement;
}

export const Application: React.FC<IApplicationProps> = props => {
  const { logger, reduxStore, httpApi, config, microfrontendsRegistry, telemetry, eventQueue, errorStub } = props;

  const isLeadFactory = getIsLeadFactory(reduxStore.getState());

  return (
    <ErrorLogComponent logger={logger} errorStub={errorStub}>
      <ApplicationContext.Provider value={{ config, logger, httpApi, microfrontendsRegistry, telemetry, eventQueue }}>
        <UiKitRoot>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore}>
              <MicrofrontendProvider registry={microfrontendsRegistry}>
                <NewbuildingBrokerModalsProvider>
                  <NewbuildingPurchaseGiftPromoProvider>
                    <NewbuildingCallbackWidgetProvider>
                      {isLeadFactory ? <LeadFactoryPage /> : <StandardPage />}
                    </NewbuildingCallbackWidgetProvider>
                  </NewbuildingPurchaseGiftPromoProvider>
                </NewbuildingBrokerModalsProvider>
                <ErrorLogComponent logger={logger}>
                  <AppEffects config={config} reduxStore={reduxStore} />
                </ErrorLogComponent>
              </MicrofrontendProvider>
            </Provider>
          </UiKitToastsContextProvider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
